<template>
    <div class="content-modal">
      <div class="card">
        <div class="modal-header border-0"></div>
        <div class="modal-body text-left pb-4">
          <div class="text-center mb-4">
            <i class="bi bi-people-fill text-primary fs-2 mb-3"></i>
            <h6>{{ $t("params.add_student_title") }}</h6>
          </div>
          <div class="form-group w-70 mx-auto">
            <label style="font-size:15px; transform:translateY(10px);" for="studentCount" class="form-label">
              {{ $t("params.student_count") }} <span class="text-danger">*</span>
            </label>
            <label for="studentCount" class="form-label">{{ $t("new_class.description") }}</label>
            <input
              type="number"
              class="form-control"
              :class="{'is-invalid': showError && !studentCount}"
              required
              id="studentCount"
              v-model="studentCount"
              min="1"
              style="height:45px"
              placeholder="Ex: 10000"
              @blur="validateField"
            >
            <div class="invalid-feedback" v-if="showError && !studentCount">
              {{ $t("params.student_count_required") || "Le nombre d'élèves est requis" }}
            </div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <argon-button
            :loading="loading"
            :active="buttonActive || showConfirmation"
            :disabled="!studentCount || studentCount < 1 || loading"
            color="success"
            variant="gradient"
            type="button"
            class="mt-1"
            style="width: 150px; height: 50px; padding-top: 15px; margin-right: 120px;"
            @click="validateAndSave"
          >
            <span v-if="!loading">{{ $t("button.save") }}</span>
            <span v-else>{{ $t("button.saving") || "Sauvegarde..." }}</span>
          </argon-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ArgonButton from "@/components/ArgonButton";
  import { updateStudentCount } from "@/utils/auth";
  import { toast } from "vue3-toastify";
  import "vue3-toastify/dist/index.css";
  
  export default {
    name: 'Studentcount_View',
    data() {
      return {
        loading: false,
        buttonActive: false,
        studentCount: null,
        showConfirmation: false,
        showError: false,
        configId: localStorage.getItem("configID"),
      };
    },
    components: {
      ArgonButton,
    },
    methods: {
      validateField() {
        this.showError = !this.studentCount;
      },
      
      validateAndSave() {
        this.showError = !this.studentCount;
        if (this.studentCount) {
          this.saveStudentCount();
        }
      },
      
      async saveStudentCount() {
        try {
          if (this.loading) {
            return;
          }
          
          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
            return;
          }
          
          // Activer l'état de chargement
          this.loading = true;
          this.buttonActive = true;
          
          console.log("Loading state:", this.loading); // Pour déboguer
          
          const response = await updateStudentCount(this.configId, this.studentCount);
          
          if (response && response.status === 200) {
            // Correction: utiliser studentCount au lieu de student_count
            this.studentCount = parseInt(this.studentCount, 10);
            
            const message = this.$t("params.student_count_updated");
            toast.success(message, {
              autoClose: 3000,
            });
            
            // Attendre un peu avant de recharger pour voir le spinner
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            const message = this.$t("params.updateFailed");
            toast.error(message, {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.error("Erreur lors de la mise à jour du nombre d'élèves:", error);
          toast.error(this.$t("params.updateFailed"), {
            autoClose: 3000,
          });
        } finally {
          // Désactiver l'état de chargement après un délai pour voir le spinner
          setTimeout(() => {
            this.loading = false;
            this.buttonActive = false;
          }, 500);
        }
      }
    },
  };
  </script>
  
  <style>
  .content-modal {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 1000;
    left: 0;
  }
  
  .card {
    background: #111c44;
  }
  
  .invalid-feedback {
    display: block;
    color: #dc3545;
    margin-top: 0.25rem;
    font-size: 0.875em;
  }
  
  .is-invalid {
    border-color: #dc3545;
  }
  
  /* Styles pour le spinner */
  .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
  </style>
  